import React from 'react'
import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  useMediaQuery,
} from '@mui/material'
import tab3 from '../../../../../../assets/img/tab3.jpg'

const ElectronicSystems = () => {
  const matches = useMediaQuery('(max-width:600px)')

  return (
    <Card
      sx={{
        backgroundColor: 'transparent',
        boxShadow: 'none',
        pt: 3,
        pb: 6,
        mb: 10,
        maxWidth: 'auto',
      }}
    >
      <Grid
        container
        alignItems='center'
        justifyContent='space-between'
        flexDirection={!matches ? 'row-reverse' : 'column'}
      >
        <Grid item xs={12} md={6}>
          <CardMedia
            sx={{ height: '40vh', marginX: '16px' }}
            image={tab3}
            title='green iguana'
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <CardContent>
            <Typography
              gutterBottom
              variant='h3'
              component='div'
              sx={{
                mb: !matches ? 4 : '',
              }}
            >
              Soluciones especializadas en sistemas eléctricos
            </Typography>
            <Typography variant='body1'>
              Nuestro enfoque se centra en la eficiencia, la seguridad y la
              confiabilidad, asegurando que tus operaciones y proyectos se
              mantengan en funcionamiento de manera óptima.
            </Typography>
          </CardContent>
        </Grid>
      </Grid>
    </Card>
  )
}

export default ElectronicSystems
